import React from 'react';
import { Star } from 'lucide-react';
import { reviews, restaurantInfo } from '../data/mock';

const Reviews = () => {
  return (
    <div className="min-h-screen vibrant-gradient-bg py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl font-black text-gray-900 mb-4">
            Vélemények
          </h1>
          <p className="text-xl text-gray-600 mb-6">
            Nézd meg, mit mondanak rólunk vendégeink!
          </p>
          
          {/* Overall Rating */}
          <div className="inline-flex items-center space-x-4 bg-gradient-to-r from-[#FFA726]/10 to-[#00BCD4]/10 px-8 py-4 rounded-2xl">
            <div className="flex items-center space-x-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-8 h-8 fill-[#FFA726] text-[#FFA726]" />
              ))}
            </div>
            <div className="text-left">
              <p className="text-4xl font-black text-gray-900">{restaurantInfo.rating}</p>
              <p className="text-sm text-gray-600">{restaurantInfo.reviewCount} vélemény</p>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#FFA726] text-[#FFA726]" />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 mb-4 leading-relaxed">
                "{review.text}"
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <p className="font-bold text-gray-900">{review.author}</p>
                <p className="text-sm text-gray-500">
                  {new Date(review.date).toLocaleDateString('hu-HU')}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews Link */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Olvass még több véleményt Google-ön!
            </h2>
            <p className="text-gray-600 mb-6">
              {restaurantInfo.reviewCount} elégedett vendég értékelése
            </p>
            <a
              href="https://www.google.com/search?q=Boldog+B%C3%BCf%C3%A9+Szigethalom"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-gradient-to-r from-[#00BCD4] to-[#00ACC1] text-white rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              Google Vélemények
            </a>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-12 text-center bg-gradient-to-r from-[#FFA726] to-[#FF9800] rounded-3xl p-12 text-white">
          <h2 className="text-3xl sm:text-4xl font-black mb-4">
            Próbáld ki te is!
          </h2>
          <p className="text-xl mb-8">
            Csatlakozz elégedett vendégeinkhez!
          </p>
          <a
            href="/menu"
            className="inline-block px-8 py-4 bg-white text-[#FFA726] rounded-xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            Rendelés most
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
